module.exports = __webpack_public_path__ + "img/9788973379330.70ccd9f1.jpg";